import styled from 'styled-components'

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  font-family: 'Inter', sans-serif;
`

export const TableContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  width: 100%;
  padding-right: 10px;
`
